/**
 * A #RRGGBB color mixed with white: 0 keeps the color, 1 is white. Used for
 * the lighter bars of past months, so every goal's tint follows its own color.
 */
export const mixWithWhite = (hex: string, amount: number): string => {
  const match = /^#?([0-9a-f]{6})$/i.exec(hex.trim());
  if (!match) return hex;
  const value = parseInt(match[1], 16);
  const share = Math.min(Math.max(amount, 0), 1);
  const channel = (shift: number) => {
    const c = (value >> shift) & 255;
    return Math.round(c + (255 - c) * share)
      .toString(16)
      .padStart(2, '0');
  };
  return `#${channel(16)}${channel(8)}${channel(0)}`.toUpperCase();
};
